import { useLocation, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { CustomSectionComp } from '../../components/custom-section/custom-section';
import MainCarousel from '../../components/home/MainCarousel';
import { selectBannersState } from '../../redux/selectors/application-selectors';

const getSectionType = (pathname) => {
  if (pathname.includes('Custom')) return 'custom';
  if (pathname.includes('DefaultHtml')) return 'defaultHtml';
  if (pathname.includes('Default')) return 'default';
  return 'unknown';
};

const CustomSection = () => {
  const location = useLocation();
  const { id, title } = useParams();

  const sectionType = getSectionType(location.pathname);
  const defaultOnly = sectionType === 'default';

  const { categoriesMainCarousel, ready, error } = useSelector(selectBannersState);
  const hasBanners = ready && !error && categoriesMainCarousel && categoriesMainCarousel.length > 0;
  const isLoadingBanners = !ready;

  return (
    <div>
      <MainCarousel
        defaultB={title === 'Default'}
        defaultOnly={defaultOnly}
        id={id}
        showHomeOnly={true}
      />
      {!hasBanners && !isLoadingBanners && <CustomSectionComp id={id} title={title} />}
    </div>
  );
};

export default CustomSection;
